<template>
  <div id="monitoring-view">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'MonitoringView',
};
</script>

<style lang="scss" scoped>
  #monitoring-view {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

</style>
